import { MessageCircleMore, PhoneCall, UserRoundCheck } from "lucide-react";
import { InquiryForm } from "@/components/site/InquiryForm";
import { PageHero } from "@/components/site/PageHero";
import { SiteLayout } from "@/components/site/SiteLayout";

export default function GeneralInquiry() {
  return (
    <SiteLayout>
      <PageHero
        currentPage="General Inquiry"
        eyebrow="A simple first step"
        title={<>Tell us where you want to <em>go next.</em></>}
        description="You do not need to know which service to request. Share your contact information and a brief comment if you would like, and the CORE office will help you begin the right conversation."
      />
      <section className="page-section inquiry-page-section">
        <div className="container inquiry-page-grid">
          <div className="inquiry-expectations">
            <p className="section-kicker">What happens next</p>
            <h2>A personal follow-up from the office.</h2>
            <article><MessageCircleMore /><div><h3>Share the basics</h3><p>Tell us how to reach you. Comments are optional and should stay brief.</p></div></article>
            <article><PhoneCall /><div><h3>We will connect</h3><p>Someone from the office will follow up to learn more and answer initial questions.</p></div></article>
            <article><UserRoundCheck /><div><h3>Choose a useful next step</h3><p>If CORE may be a fit, the office will explain scheduling and any information needed before a visit.</p></div></article>
          </div>
          <InquiryForm kind="general" />
        </div>
      </section>
    </SiteLayout>
  );
}
